import { createSlice } from '@reduxjs/toolkit';
import { merge, reduce } from 'lodash';

import { ENTITY_TYPES } from 'src/constants';

const initialState = reduce(
  ENTITY_TYPES,
  (result) => {
    result = merge(
      {
        expectedRepayment: null,
        loading: false,
      },
    );
    return result;
  },
  {},
);

const slice = createSlice({
  name: 'expectedRepayment',
  initialState,
  reducers: {
    createExpectedRepaymentStart(state, { payload }) { },
    createExpectedRepaymentSuccess(state, { payload }) { },
    createExpectedRepaymentFailure(state, { payload }) { },
    getExpectedRepaymentStart(state, { payload }) {
      state.loading = true;
    },
    getExpectedRepaymentSuccess(state, { payload }) {
      const { response } = payload;
      state.expectedRepayment = response;
      state.loading = false;
    },
    getExpectedRepaymentFailure(state, { payload }) { },
    editExpectedRepaymentStart(state, { payload }) {
      state.loading = true;
    },
    editExpectedRepaymentSuccess(state, { payload }) {
      const { response } = payload;
      state.loading = false;
      state.payment = response;
    },
    editExpectedRepaymentFailure(state, { payload }) { },
  },
});

export const { actions } = slice;

export default slice.reducer;
